import styled, {css} from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {Platform} from 'react-native';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';
import FastImage from 'react-native-fast-image';

interface Check {
  check?: boolean;
}

export const Container = styled.View`
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.ScrollView`
  padding: 0 24px;
  flex: 1;
`;

export const Title = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
`;

export const Section = styled.View`
  border-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
  margin: 0 -24px;
  padding: 0 24px;
  padding-bottom: ${RFValue(12)}px;
  margin-bottom: ${RFValue(12)}px;
`;

export const SectionHeader = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${RFValue(12)}px;
`;

export const LinkButton = styled.TouchableOpacity`
  border-style: solid;
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.blue};
`;
export const LinkButtonText = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.blue};
`;

export const CheckoutBrand = styled.View`
  width: ${RFValue(50)}px;
  height: ${RFValue(50)}px;
  background: ${({theme}) => theme.colors.yellow};
  border: 2px solid ${({theme}) => theme.colors.image_border};
  border-radius: ${RFValue(12)}px;
  align-items: center;
  justify-content: center;
`;
export const CheckoutIcon = styled(FontAwesome5)`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(20)}px;
`;

export const ProductValueContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ValueContainer = styled.View``;

export const Value = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(16)}px;
`;

export const ValueGroup = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const ValueDescription = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(12)}px;
`;

export const Item = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${RFValue(10)}px;
`;

export const ItemTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
`;

export const ItemName = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
`;

export const Footer = styled.View`
  padding: 0 24px;
  padding-top: ${RFValue(6)}px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
`;

export const PaymentTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  margin-left: ${RFValue(12)}px;
`;

export const PaymentInfo = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  margin-bottom: ${RFValue(16)}px;
`;

export const Payment = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const BrandContainer = styled.View`
  width: ${RFValue(35)}px;
  height: ${RFValue(35)}px;
  align-items: center;
  border: 2px solid ${({theme}) => theme.colors.border3};
  border-radius: ${RFValue(10)}px;
  justify-content: center;
`;

export const BrandImage = styled(FastImage)`
  width: ${RFValue(20)}px;
  height: ${RFValue(13)}px;
`;

export const PaymentMethodInfo = styled.View`
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const CheckIcon = styled(FontAwesome5)<Check>`
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.placeholder};

  ${({check, theme}) =>
    check &&
    css`
      color: ${theme.colors.blue};
    `}
`;
